import { atomWithSuperJsonLocalStorage } from './storage';

export const gcooEventParticipatedAtom = atomWithSuperJsonLocalStorage('gcooEventParticipated', {
  participated: false,
  maintainDate: new Date(),
});
